export default "__VITE_ASSET__Cb9hOUZa__"